import React from "react";

type Row = { capability:string; viewer?:boolean; steward?:boolean; builder?:boolean; ops?:boolean };
const rows: Row[] = [
  { capability: "Read everything (read-only)", viewer:true, steward:true, builder:true, ops:true },
  { capability: "Propose Context changes (ChangeSet)", viewer:false, steward:true, builder:false, ops:true },
  { capability: "Propose Apps/APIs/IoT/DAM (ChangeSet)", viewer:false, steward:false, builder:true, ops:true },
  { capability: "Approve/Reject ChangeSets", viewer:false, steward:false, builder:false, ops:true },
  { capability: "Run smoke / dev-only ops", viewer:false, steward:false, builder:false, ops:true },
];

export default function RoleMatrix({ roles }:{ roles: string[] }){
  function cell(need:boolean){ return <td className={`p-2 text-center ${need?"":"opacity-30"}`}>{need ? "✓" : "—"}</td>; }
  const have = new Set(roles || []);
  return (
    <div className="overflow-x-auto rounded-2xl border">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="text-left border-b bg-gray-50">
            <th className="p-2">Capability</th>
            <th className="p-2 text-center">viewer</th>
            <th className="p-2 text-center">steward</th>
            <th className="p-2 text-center">builder</th>
            <th className="p-2 text-center">ops</th>
            <th className="p-2 text-center">you</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r,i)=>(
            <tr key={i} className="border-b">
              <td className="p-2">{r.capability}</td>
              {cell(!!r.viewer)}{cell(!!r.steward)}{cell(!!r.builder)}{cell(!!r.ops)}
              <td className="p-2 text-center font-semibold">{Array.from(have).join(", ") || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}


